module.exports = __webpack_public_path__ + "img/logo_horizontal.6a1158f0.png";